import { LitElement, html, TemplateResult } from 'lit';
import {customElement} from 'lit/decorators.js';
import { EVENTS } from '../api/ui';

@customElement('berner-frame')
export class BernerFrame extends LitElement {

    firstUpdated(): void {
        // consider Escape press as a click out
        window.document.onkeyup = (e: any) => {
            if (e.key === 'Escape') {
                window.dispatchEvent(new Event(EVENTS.CLICK_OUT));
            }
        };
    }

    render(): TemplateResult {
        const onClick = (e: any) => {
            // detect unhandled clicks, used to close dropdowns etc
            window.dispatchEvent(new Event(EVENTS.CLICK_OUT));
        };

        return html`<head content="width=device-width, initial-scale=1">
                <link rel="stylesheet" href="./css/berner-frame.css" />
            </head>

            <main @click=${onClick}>
                <slot></slot>
            </main>`;
    }
}
